const ITEMS = ["Flights", "Hotels", "Holiday Packages", "Buses", "Train Tickets", "Zero train fees above ₹2,000"];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-ivory sm:text-3xl">{item}</span>
        <span className="h-2 w-2 rotate-45 bg-cyan" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section className="marquee-track overflow-hidden border-y border-ink/10 bg-emerald py-6" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);

export default Marquee;
